import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import DocStatusTag from '_components/utils/DocStatusTag';
import Avatar from '../Avatar';
import { getLayoffStatus } from '../useLayoff';
import { useSignatureList } from './useSignatures';
import styles from '../layoff.module.scss';

const formatDate = (value) =>
  value ? moment(value).format('MMM D, YYYY') : '—';

const Section = ({ title, empty, rows, actionLabel, dateLabel, dateOf }) => (
  <section className={styles.signature_section}>
    <h2 className={styles.section_title}>
      {title} <span className={styles.muted}>({rows.length})</span>
    </h2>
    {rows.length === 0 ? (
      <div className={styles.empty_box}>{empty}</div>
    ) : (
      <ul className={styles.signature_rows}>
        {rows.map((row) => {
          const status = getLayoffStatus(row.status);
          return (
            <li key={row.hash} className={styles.signature_row}>
              <div className={styles.person}>
                <Avatar
                  photo={row.employee.profile_photo}
                  name={row.employee.name}
                />
                <div className={styles.employee_text}>
                  <span className={styles.employee_name}>
                    {row.employee.name}
                  </span>
                  <span className={styles.muted}>
                    {row.employee.role || 'No role'} · {row.crew}
                  </span>
                </div>
              </div>
              <div className={styles.signature_meta}>
                <span className={styles.muted}>{dateLabel}</span>
                <span>{dateOf(row)}</span>
              </div>
              <DocStatusTag
                status={row.status_label}
                bgColor={status.bg}
                fontColor={status.fg}
                className={styles.status_tag}
              />
              <Link
                to={`/layoff/sign/${row.hash}`}
                className={`button ${styles.small_button}`}
              >
                {actionLabel}
              </Link>
            </li>
          );
        })}
      </ul>
    )}
  </section>
);

const SignatureList = () => {
  const { data, isLoading, isError } = useSignatureList();

  return (
    <div className='activity-log'>
      <div className='header'>
        <div className='report_tbl_head sold_rpt_mbl_flx'>
          <h4 className='graph_header'>Lay-off signatures</h4>
        </div>
      </div>
      <div className='white'>
        <div className={`inner_container col-lg-12 ${styles.tracker}`}>
          {isLoading && (
            <div className={styles.empty}>
              <img
                alt='Loading'
                src={require('../../assets/images/loader.gif').default}
              />
            </div>
          )}
          {isError && (
            <div className={styles.empty}>
              Lay-off notices could not be loaded. Please refresh the page.
            </div>
          )}
          {data && (
            <>
              <Section
                title='Waiting for your signature'
                empty='Nothing to sign right now.'
                rows={data.to_sign}
                actionLabel='Review and sign'
                dateLabel='Sent'
                dateOf={(row) => formatDate(row.sent_at)}
              />
              <Section
                title='Signed, waiting for the employee'
                empty='No signed notices are waiting for an employee.'
                rows={data.waiting_for_employee}
                actionLabel='Open'
                dateLabel='Last day worked'
                dateOf={(row) => formatDate(row.effective_date)}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default SignatureList;
